import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-export-dr',
  templateUrl: './export-dr.component.html',
  styleUrls: ['./export-dr.component.scss'],
})
export class ExportDrComponent implements OnInit {
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  is_dispatched_to_patient;
  is_dispatched_to_reception;
  result_id;
  dispatchPatientLoad: boolean = false;
  dispatchReceptionLoad: boolean = false;
  id: string = '';
  fileName = 'ref-dr-list.xlsx';
  dept_code = '';
  sub_dept_code = '';
  Template_Text = '';
  depts: any = [];
  subDepts: any = [];
  constructor(
    public router: Router,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    console.log(this.id);
    this.setting.getRefDr().subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.reverse();
        this.isLoading = false;
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  dept(event) {
    localStorage.setItem('dept_code', event.value);
    console.log(this.dept_code);
  }
  sub(event) {
    localStorage.setItem('sub_dept_code', event.value);
    console.log(this.sub_dept_code);
  }
  searchEcounters() {
    this.isLoading = true;
    this.setting.getItems1(this.dept_code, this.sub_dept_code).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess;
        this.isLoading = false;
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
